import { NextSeo } from 'next-seo'
import { MainLayout } from '@/components/layout/MainLayout'
import HeroSection from '@/components/sections/HeroSection'
import KeyTrends from '@/components/sections/KeyTrends';
import Testimonials from '@/components/sections/Testimonials';

export const HomePage: React.FC = () => {

  return (
    <>
      <NextSeo
        title={'Start in Türkiye | Investment Office Türkiye'}
        description={
          ''
        }
        twitter={{
          cardType: 'summary_large_image',
        }}
        openGraph={{
          title: 'Start in Türkiye | Investment Office Türkiye',
          description:
            '',
          images: [
            {
              url: `https://startinturkiye.azurewebsites.net/pageimage.webp`,
              width: 1024,
              height: 1024,
              type: 'image/jpeg',
            },
          ],
        }}
      />
      <MainLayout>
        <>
          <HeroSection />
          <Testimonials />
          <KeyTrends />
          {/* <PolicyAreasSection
            cards={content.policyAreasSection.cards}
            tagline={content.policyAreasSection.tagline}
            heading={content.policyAreasSection.heading}
          />
          <QualityFdiSlider
            slides={content.qualityFdiSlider.slides}
            tagline={content.qualityFdiSlider.tagline}
            heading={content.qualityFdiSlider.heading}
          />

          <QualityFdiSection
            mockupImage={content.qualityFdiSection.mockupImage}
            mockupAlt={content.qualityFdiSection.mockupAlt}
            pdfLink={content.qualityFdiSection.pdfLink}
            pdfLabel={content.qualityFdiSection.pdfLabel}
            tagline={content.qualityFdiSection.tagline}
            heading={content.qualityFdiSection.heading}
            features={content.qualityFdiSection.features}
          />

          <InsightsSection
            tagline={content.insightsSection.tagline}
            heading={content.insightsSection.heading}
            tabs={content.insightsSection.tabs}
          /> */}
        </>
      </MainLayout>
    </>
  )
}
